module.exports = __webpack_public_path__ + "img/Jiani.2bc9d7c9.jpeg";